import React, { FunctionComponent } from "react";
import { strings } from "../../../../localization/LocalizedStrings";

export const DocumentationSubscriptionWithMercadoPago: FunctionComponent = () => {
  return (
    <div>
      <section id={"title"} />
      <h1>{strings.doc_mercado_pago_subscriptions.title}</h1>
      <p>{strings.doc_mercado_pago_subscriptions.description}</p>
    </div>
  );
};
